import Link from "next/link";
import Head from "next/head";
import { useEffect } from "react";
import Layout from "../components/Layout";
import ContentWrapper from "../components/ContentWrapper";
import { WYSIWYG } from "../components/styles/TextStyles";
import { request } from "../lib/datocms";
import { StructuredText } from "react-datocms";
import Image from "next/image";
import styled from "styled-components";
import { useStore } from "./_app";

const COMMISSIONS_QUERY = `query CommissionsPage {
  commission {
    title
    content {
      value
    }
    commissionsImage {
      responsiveImage {
        srcSet
        webpSrcSet
        sizes
        src
        width
        height
        aspectRatio
        alt
        title
        bgColor
        base64
      }
    }
  },
}`;

export async function getStaticProps() {
  const data = await request({
    query: COMMISSIONS_QUERY,
  });
  return {
    props: { data },
  };
}

export default function CommissionPage({ data }) {
  const setHeaderOpaque = useStore((state) => state.setHeaderOpaque);

  useEffect(() => {
    setHeaderOpaque();
  }, []);

  return (
    <Layout>
      <Head>
        <title>veikkanen - Commissions</title>
      </Head>
      <ContentWrapper introBuffer={true}>
        <WYSIWYG>
          <StructuredText data={data.commission.content} />
        </WYSIWYG>
        <CommissionsImageWrap>
          <Image
            src={data.commission.commissionsImage.responsiveImage.src}
            width={data.commission.commissionsImage.responsiveImage.width}
            height={data.commission.commissionsImage.responsiveImage.height}
            layout="responsive"
          />
        </CommissionsImageWrap>
      </ContentWrapper>
    </Layout>
  );
}

const CommissionsImageWrap = styled.div`
  margin: calc(var(--gridMarginGap) * 4) 0;
`;
